module.exports = __webpack_public_path__ + "static/media/heart.d1987cc2.svg";